// extracted by mini-css-extract-plugin
export default {"link":"iJ-z","disabled":"jJ-z"};